import React from 'react';

const UserInfo = ({ userInfo }) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between">
        <span className="font-semibold">Desired Salary / Day Rate</span>
        <span className="text-[#77838F]">
          {userInfo.OfferedSalary || 'N/A'}
        </span>
      </div>
      <div className="flex justify-between">
        <span className="font-semibold">Years of Experience</span>
        <span className="text-[#77838F]">
          {userInfo.years_of_experience || 'N/A'}
        </span>
      </div>
      <div className="flex justify-between">
        <span className="font-semibold">Gender</span>
        <span className="text-[#77838F]">{userInfo.gender || 'N/A'}</span>
      </div>
      {/* <div className="flex justify-between">
        <span className="capitalize font-semibold">Age</span>
        <span className="text-[#77838F]">{candidateInfo.Age || 'N/A'}</span>
      </div> */}
      {/* <div className="flex justify-between">
        <span className="font-semibold">Qualification</span>
        <span className="text-[#77838F]">
          {userInfo.Qualification || 'N/A'}
        </span>
      </div>
      <div className="flex justify-between">
        <span className="font-semibold">Languages</span>
        <span className="text-[#77838F]">
          {userInfo.Languages || 'N/A'}
        </span>
      </div> */}
      <div className="flex justify-between">
        <span className="font-semibold">Email</span>
        <span className="text-[#77838F]">{userInfo.email || 'N/A'}</span>
      </div>
      <div className="flex justify-between">
        <span className="font-semibold">Phone Number</span>
        <span className="text-[#77838F]">{userInfo.phone_number || 'N/A'}</span>
      </div>
    </div>
  );
};

export default UserInfo;
